import {
  retrieveReportsMatterRecordRequestsReportV1,
  type RetrieveReportsMatterRecordRequestsReportInput,
} from "@/lib/data/requests";
import { queryKeys } from "@/lib/data/static";

export const retrieveReportsMatterRecordRequestsReportQueryOptions = (
  filters: RetrieveReportsMatterRecordRequestsReportInput,
) => ({
  queryKey: [
    queryKeys.reports,
    "matter-record-requests-report",
    filters,
  ] as const,
  queryFn: () => retrieveReportsMatterRecordRequestsReportV1(filters),
});
